import React from "react";
import styles from "./insRangeChartAxisLabel.module.scss";
import { InsLabelTooltip } from "components/widgets/base/common/insLabelValueTooltip";
export const InsRangeChartAxisLabel = (props) => React.createElement("div", { className: styles.unPrinciplesLabelsTooltip },
    props.category,
    React.createElement("div", { className: "highcharts-tooltip" },
        React.createElement("span", { className: styles.unPrinciplesLabelsTooltipText },
            React.createElement(InsLabelTooltip, { labels: [props.description] }))));
